import { ACCENT, MUTED, type IllustrationProps } from './types';

/**
 * IllustrationAcquisitions — empty-state art for acquisitions (buys / sales / trades).
 *
 * Depicts: a paper receipt with line items and a dollar-sign coin overlapping
 * the lower-right corner.
 *
 * Resource: acquisitions. Shell: any.
 */
export function IllustrationAcquisitions({ size = 120, className, style }: IllustrationProps) {
  const h = (size * 90) / 120;
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 120 90"
      fill="none"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <ellipse cx="60" cy="82" rx="36" ry="3" stroke={MUTED} strokeWidth={1.5} />
      <path
        d="M40 14 L80 14 L80 74 L74 70 L68 74 L62 70 L56 74 L50 70 L44 74 L40 70 Z"
        stroke={ACCENT}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <line
        x1="46"
        y1="26"
        x2="74"
        y2="26"
        stroke={ACCENT}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <line
        x1="46"
        y1="34"
        x2="68"
        y2="34"
        stroke={MUTED}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <line
        x1="46"
        y1="40"
        x2="70"
        y2="40"
        stroke={MUTED}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <line
        x1="46"
        y1="46"
        x2="66"
        y2="46"
        stroke={MUTED}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <line
        x1="46"
        y1="56"
        x2="74"
        y2="56"
        stroke={ACCENT}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <circle cx="84" cy="64" r="10" stroke={ACCENT} strokeWidth={1.5} />
      <path
        d="M84 58 L84 70 M81 61 L87 61 M81 67 L87 67"
        stroke={ACCENT}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}
